// Libraries
import Choices from "choices.js";
export { Choices };
import "../../node_modules/choices.js/public/assets/styles/choices.css";
import $ from "jquery";
export { $ };
import "lazysizes";
import "objectFitPolyfill";
import "../../node_modules/waypoints/lib/noframework.waypoints.min";

// Modules
import { accordionHeight, accordionToggle } from "./modules/accordion";
import "./modules/carousels";
import { carouselPaginationHeight } from "./modules/carousels";
import { customCheckbox, customSelectClass } from "./modules/contactForm7";
import "./modules/eventLocation";
import { eventsFilter } from "./modules/eventsFilter";
import "./modules/filterClose";
import { filterToggle } from "./modules/filterToggle";
import "./modules/heroStory";
import { heroStoryImagePosition } from "./modules/heroStory";
import { iframeScale } from "./modules/iframe";
import "./modules/lenis";
import "./modules/locationsMenu";
import "./modules/locationsSearch";
import { moduleMenus } from "./modules/menus";
import "./modules/menusFixes";
import { navMenuScale, navMenuToggle } from "./modules/navMenu";
import {
  newsEventsScale,
  newsEventsSet,
  newsEventsToggle,
} from "./modules/newsEvents";
import { newsFilter } from "./modules/newsFilter";
import "./modules/pageScrolled";
// import { pageTransition } from "./modules/pageTransition";
import { preloader } from "./modules/preloader";
import { privateEventClose, privateEventToggle } from "./modules/privateEvent";
import "./modules/promo";
import { resizing } from "./modules/resizing";
import "./modules/scroll";
import { video } from "./modules/video";
import {
  initNewsletterForms,
  initFooterNewsletterForm,
} from "./modules/newsletterForm";
import enquiryForm from "./modules/enquiryForm";
import { initPeBrochureForm } from "./modules/peBrochureForm";
import { initPopups } from "./helpers/popups";

// Import main scss file here. This will compile to a css file in the dist folder
import "../scss/style.scss";

// Load functions
window.addEventListener("load", function () {
  accordionToggle();
  customCheckbox();
  customSelectClass();
  eventsFilter();
  filterToggle();
  moduleMenus();
  navMenuToggle();
  newsEventsSet();
  newsEventsToggle();
  newsFilter();
  enquiryForm();
  //   pageTransition();
  privateEventClose();
  privateEventToggle();
  initNewsletterForms();
  initFooterNewsletterForm();
  initPeBrochureForm();
  video();
  refreshPage();
  initPopups();
  document.body.classList.add("loaded");
  preloader();
});

// Resize functions
window.addEventListener("resize", function () {
  resizing();
  refreshPage();
});

// Load and Resize functions
function refreshPage() {
  console.log("test");
  accordionHeight();
  heroStoryImagePosition();
  iframeScale();
  navMenuScale();
  newsEventsScale();
  carouselPaginationHeight();
  Waypoint.refreshAll();
}

export { refreshPage };
